export default "__VITE_ASSET__CsAgjaRr__"